<div class="modal-body">
  <app-loader>
    <div class="d-flex justify-content-center mt-4">
      <b style="width:4rem" class="m-auto"><small class="text-center">Loading{{dots$ | async}}</small></b>
    </div>
  </app-loader>
</div>
